module.exports = __webpack_public_path__ + "img/idcard.76d11ed2.png";